import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

/**
 * Generated class for the MaintenacePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage({
  name: 'maintenace-Page'
})

@Component({
  selector: 'page-maintenace',
  templateUrl: 'maintenace.html',
})
export class MaintenacePage {

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  gotoLoginPage(){
    this.navCtrl.setRoot('DashboardLoginPage');
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad MaintenacePage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/maintenace/maintenace.ts